<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      scrollable
      hide-overlay
      persistent
      class="dialogCertificate overflow-y-hidden"
    >
      <v-card color="#1A1C1D" class="mx-auto">
        <v-card-title class="pa-0">
          <v-toolbar
            dark
            :color="type == 'line_oa' ? '#32B1EE' : '#00a99d'"
            dense
            flat
          >
            <v-toolbar-title class="pl-3 w-700 font-24"></v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn fab text small color="#103362" @click="closeDialog">
              <img
                height="14"
                width="14"
                :src="require('@/assets/icon/x_white.png')"
              />
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text style="height: 100%">
          <div class="PDFsize">
            <pdf
              v-for="i in numPages"
              :key="i"
              :src="pdfsrc"
              :page="i"
              style="display: inline-block; width: 100%; margin-top: 10px"
            ></pdf>
          </div>
          <v-btn
            :color="type == 'line_oa' ? '#32B1EE' : '#00a99d'"
            fab
            dark
            bottom
            left
            class="download_btn"
            @click="download()"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoadingDownload" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          <div class="pt-2 white--text font-16">{{ textLoading }}</div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdf from "vue-pdf-signature";
// import { saveAs } from 'file-saver';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      pdf_url: "",
      dialog: false,
      pageCount: [],
      pdfsrc: null,
      numPages: undefined,
      type: "",
      isLoadingDownload: false,
      documentId: "",
      fileId: "",
      textLoading: "",
      pdfBase: null,
      share_token: "",
    };
  },
  methods: {
    async openDialog(url, type, documentId, fileId, typeDoc, share_token) {
      this.documentId = documentId;
      this.fileId = fileId;
      this.isLoadingDownload = true;
      this.type = type;
      this.share_token = share_token;
      this.textLoading = "กำลังเปิดเอกสาร";
      if (typeDoc == "health_check") {
        if (fileId) {
          this.pdf_url = url;
          await this.data_blob(url);
        } else {
          this.genPdf_base(documentId);
        }
      } else {
        this.pdf_url = url;
        await this.data_blob(url);
      }
    },
    async data_blob(response) {
      this.pdfsrc = await pdf.createLoadingTask(response);
      this.pdfsrc.promise.then((pdf) => {
        this.numPages = pdf.numPages;
        this.isLoadingDownload = false;
        this.dialog = true;
      });
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    async download() {
      this.isLoadingDownload = true;
      this.textLoading = "กำลังดาวน์โหลดเอกสาร";
      // const link = document.createElement("a");
      // link.href = this.pdf_url+'&status_view=false';
      // link.download = "file"
      // console.log("link", link.href);
      // link.click();
      // v. ====================================================
      // var url = this.pdf_url+'&status_view=false'
      // var xhr = new XMLHttpRequest();
      // xhr.open('GET', url, true);
      // xhr.responseType = 'blob';
      // xhr.onload = function() {
      //   console.log("99999", this.status );
      //   if (this.status == 200) {
      //     var myBlob = this.response;
      //     var link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(myBlob);
      //     link.download = "yourname.pdf";
      //     link.click();
      //   }
      // };
      // xhr.send();
      // v2 ======================================================
      // console.log("this.isIOS:",this.isIOS());
      if (this.isIOS()) {
        console.log("isIOS");
        window.open(this.pdf_url + "&status_view=false", "_blank");
        this.isLoadingDownload = false;
      } else {
        console.log("non isIOS");
        const link = document.createElement("a");
        link.href = this.pdf_url + "&status_view=false";
        link.target = "_blank";
        link.download = "downloaded.pdf";
        link.click();
        this.isLoadingDownload = false;
      }

      // v3 ============================================================
      // try {
      //   const pdfUrl = this.pdf_url+'&status_view=true';
      //   const response = await fetch(pdfUrl);
      //   const blob = await response.blob();
      //   saveAs(blob, 'downloaded.pdf');
      // } catch (error) {
      //   console.error('Error downloading PDF:', error);
      // }
    },
    closeDialog() {
      this.pdfsrc = null;
      this.dialog = false;
       this.pdf_url = ""
    },
    async genPdf_base(documentId) {
      try {
        let params = new URLSearchParams();
        params.append("doc_id", documentId);
        params.append("one_access_token", this.share_token);
        const url = `${process.env.VUE_APP_BACKEND_URL}/mini_app/v1/sign/create-pdf?${params}`;
        this.pdf_url = url
        await this.data_blob(url);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.download_btn {
  position: absolute;
  bottom: 15px;
  right: 10px;
}

::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 5px !important;
}
</style>
